import React, { useRef } from 'react'
import PropTypes from 'prop-types'

// Components
import MapRoute from '../MapRoute'

// Styles
import { MapWrapper } from './index.style'

// Images
import WorldMap from '../assets/map.jpg'
import ChichenItza from '../assets/locations/chichen-itza.jpg'
import ChristTheRedeemer from '../assets/locations/christ-the-redeemer.jpg'
import IguazaFalls from '../assets/locations/iguaza-falls.jpg'
import MachuPichu from '../assets/locations/machu-pichu.jpg'
import GreatBarrierReef from '../assets/locations/great-barrier-reef.jpg'
import GreatWallOfChina from '../assets/locations/great-wall.jpg'
import TajMahal from '../assets/locations/taj-mahal.jpg'
import Petra from '../assets/locations/petra.jpg'
import Pyramids from '../assets/locations/pyramids.jpg'
import TempleOfArtemis from '../assets/locations/temple-of-artemis.jpg'
import Colosseum from '../assets/locations/colosseum.jpg'
import Amsterdam from '../assets/locations/amsterdam.jpg'
import Berlin from '../assets/locations/berlin.jpg'
import Copenhagen from '../assets/locations/copenhagen.jpg'
// import StPetersberg from '../assets/locations/st-petersberg.jpg'
import NewYork from '../assets/locations/new-york.jpg'

// SVGs
import Route1 from '../../svgs/Routes/1'
import Route2a from '../../svgs/Routes/2a'
import Route2b from '../../svgs/Routes/2b'
import Route3 from '../../svgs/Routes/3'
import Route4 from '../../svgs/Routes/4'
import MapLocation from '../MapLocation'
import { colors } from '../../../styles/vars/colors.style'

const MapRoutes = ({ id, mapIndex }) => {
  // const [ref, inView] = useInView({ triggerOnce: true })

  const route1Path = useRef(),
    route2aPath = useRef(),
    route2bPath = useRef(),
    route3Path = useRef(),
    route4Path = useRef()

  return (
    <MapWrapper>
      <img src={WorldMap} alt="World map showing routes" />
      <MapLocation
        inView={true}
        left={24.3}
        top={42}
        active={mapIndex === 0}
        delay={0.5}
        image={ChichenItza}
        label={'Chichén Itzá, Cozumel, Mexico'}
      />
      <MapLocation
        inView={true}
        left={37.5}
        top={66}
        active={mapIndex === 0}
        delay={2.3}
        image={ChristTheRedeemer}
        label={'Christ the Redeemer, Rio de Janeiro, Brazil'}
      />
      <MapLocation
        inView={true}
        left={34.5}
        top={72}
        active={mapIndex === 0}
        delay={2.6}
        image={IguazaFalls}
        label={'Iguazu Falls, Buenos Aires, Argentina'}
      />
      <MapLocation
        inView={true}
        left={30}
        top={60.5}
        active={mapIndex === 0}
        delay={4}
        image={MachuPichu}
        label={'Machu Picchu, Lima, Peru'}
      />
      <MapRoute
        inView={true}
        left={17.9}
        top={36.5}
        width={23.4}
        active={mapIndex === 0}
        route={route1Path}
        duration={6.05}
        color={colors.teal}
      >
        <Route1 stroke={colors.teal} opacity={0.3} />
        <Route1 stroke={colors.teal} offset={true} forwardRef={route1Path} />
      </MapRoute>
      <MapRoute
        inView={true}
        left={0}
        top={32.5}
        width={18}
        active={mapIndex === 1}
        route={route2aPath}
        first={true}
        duration={2.25}
        color={colors.lightPink}
      >
        <Route2a stroke={colors.lightPink} opacity={0.3} />
        <Route2a
          stroke={colors.lightPink}
          offset={true}
          forwardRef={route2aPath}
        />
      </MapRoute>
      <MapLocation
        inView={true}
        left={89.5}
        top={67.5}
        active={mapIndex === 1}
        delay={4.7}
        image={GreatBarrierReef}
        label={'Great Barrier Reef, Cairns, Australia'}
      />
      <MapLocation
        inView={true}
        left={82.8}
        top={26.8}
        active={mapIndex === 1}
        delay={5.7}
        image={GreatWallOfChina}
        label={'Great Wall of China, Beijing, China'}
      />
      <MapLocation
        inView={true}
        left={71.7}
        top={38.5}
        active={mapIndex === 1}
        delay={8}
        image={TajMahal}
        label={'The Taj Mahal, Cochin, India'}
      />
      <MapRoute
        inView={true}
        right={-0.3}
        top={31.5}
        width={33}
        active={mapIndex === 1}
        route={route2bPath}
        second={true}
        duration={7.9}
        delay={1.5}
        color={colors.lightPink}
      >
        <Route2b stroke={colors.lightPink} opacity={0.3} />
        <Route2b
          stroke={colors.lightPink}
          offset={true}
          forwardRef={route2bPath}
        />
      </MapRoute>

      <MapLocation
        inView={true}
        left={53.9}
        top={28.5}
        active={mapIndex === 2}
        delay={4.9}
        image={Colosseum}
        label={'The Colosseum, Rome, Italy'}
      />
      <MapRoute
        inView={true}
        right={32.9}
        top={26.5}
        width={22.7}
        active={mapIndex === 2}
        route={route3Path}
        duration={6}
        color={colors.lightOrange}
      >
        <Route3 stroke={colors.lightOrange} opacity={0.3} />
        <Route3
          stroke={colors.lightOrange}
          offset={true}
          forwardRef={route3Path}
        />
      </MapRoute>
      <MapLocation
        inView={true}
        left={51}
        top={23.6}
        active={mapIndex === 3}
        delay={1.5}
        image={Amsterdam}
        label={'Amsterdam, The Netherlands'}
      />
      <MapLocation
        inView={true}
        left={54}
        top={23.4}
        active={mapIndex === 3}
        delay={1.8}
        image={Berlin}
        label={'Berlin, Germany'}
      />
      <MapLocation
        inView={true}
        left={53.7}
        top={15.2}
        active={mapIndex === 3}
        delay={1.7}
        image={Copenhagen}
        label={'Copenhagen, Denmark'}
      />
      <MapLocation
        inView={true}
        left={28.5}
        top={28}
        active={mapIndex === 3}
        delay={4.3}
        image={NewYork}
        label={'New York, New York'}
      />
      <MapRoute
        inView={true}
        left={27.8}
        top={11.5}
        width={29.7}
        active={mapIndex === 3}
        route={route4Path}
        duration={5.2}
        color={colors.lightGreen}
      >
        <Route4 stroke={colors.lightGreen} opacity={0.3} />
        <Route4
          stroke={colors.lightGreen}
          offset={true}
          forwardRef={route4Path}
        />
      </MapRoute>
    </MapWrapper>
  )
}

MapRoutes.propTypes = {
  id: PropTypes.string.isRequired,
  mapIndex: PropTypes.number,
}

export default MapRoutes
